// based on crm_ui/tasks/data/api/UserMarketPlaceIntegrationsApi
import http from 'hub-http/clients/apiClient';
export function fetchNativeIntegrationAppStatus(appId) {
  const queryParams = `appId=${encodeURIComponent(appId)}`;
  return http.get(`integrators/v1/portal-installs/native-statuses?${queryParams}`);
}